import { GLServiceBase, ServiceRoute } from "commonui";
import { IAssetListService } from "./interface";
import { AssetTagResponseModel, AssetTagSaveParamModel } from "./model";

class TagServiceClass extends GLServiceBase<any, any> implements IAssetListService {
	serviceRoute: ServiceRoute = { prefix: "content/v1/tags" };

	constructor() {
		super();
	}

	getTagsList(): Promise<AssetTagResponseModel[]> {
		return this.get();
	}

	saveTag(param: AssetTagSaveParamModel): Promise<AssetTagResponseModel> {
		return this.create(param);
	}
}

export const TagsService = new TagServiceClass();
